import { IBaseFieldModel } from './../base/blueprint-field-base.model';
import { BaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFieldCheckboxModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  value: boolean;
}

export class FieldCheckboxModel extends BaseFieldModel implements IFieldCheckboxModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public value: boolean,
  ) {
    super(isRequired, isReadOnly);
  }
}
